export default __webpack_public_path__ + "static/media/palcnetworks_logo.f934cf76.svg";